import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=40b97914"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"
import style0 from "./EmptyLayout.vue?vue&type=style&index=0&id=40b97914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports